/* eslint-disable jsx-a11y/img-redundant-alt */
import { useState } from "react";
import { Button, Form, Input, Modal, Result } from "antd";
import heroImage from "../assets/images/pexels-omotayo-tajudeen-3213283.jpg";
import { useNavigate } from "react-router-dom";
import { CustomerResponse } from "../models/customer-response";
import axios from "axios";
import { BASE_URL } from "../common/config";
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  const showFailedModal = () => {
    setIsFailedModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsFailedModalOpen(false);
  };

  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    setIsLoading(true);
    const phone = values.phone;
    const phoneWithCountryCode = `260${phone}`;

    try {
      const response = await axios.get<CustomerResponse>(
        `${BASE_URL}/customers/${phoneWithCountryCode}`
      );
      if (response) {
        showModal();
      }
    } catch (error: any) {
      if (error.response !== undefined && error.response.status === 404) {
        setIsLoading(false);
        history(`/verify/${phoneWithCountryCode}`);
      }

      showFailedModal();
      setIsLoading(false);
    }
  };

  return (
    // isLoading ? (
    //   <Loader />
    // ) :
    // (
    <>
      <div
        className="h-screen bg-cover bg-center bg-gray-950"
        style={{
          backgroundImage: `url(${heroImage})`,
          opacity: 0.8,
        }}
      >
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between p-10 h-screen ">
          <div className="text-white text-center lg:text-left">
            <h1 className="text-4xl font-bold">
              Welcome to the Patumba Verification Portal
            </h1>
            <p className="text-lg mt-5">
              Let's get you verified and start earning
            </p>
          </div>
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
            className="lg:w-1/2"
          >
            <Form.Item
              name="phone"
              rules={[
                { required: true, message: "Please input your phone number!" },
              ]}
            >
              <Input
                addonBefore={260}
                style={{ width: "100%" }}
                maxLength={9}
                minLength={9}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button bg-blue-500"
                style={{ width: "100%" }}
                loading={isLoading}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <Modal open={isModalOpen} onCancel={handleCancel} footer={null}>
        <Result
          status="success"
          title="Your details are already verified!"
          subTitle="You can continue saving and earning with Patumba"
        />
      </Modal>

      <Modal open={isFailedModalOpen} onCancel={handleCancel} footer={null}>
        <Result
          status="500"
          title="500"
          subTitle="Sorry, something went wrong."
        />
      </Modal>
    </>
  );
}

export default Hero;
